import ActionButton from '@repo/ui/action-button'
import { UnlinkIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { Fragment } from 'react/jsx-runtime'
import { toast } from 'sonner'

import { API } from '../../../api/apis.config'
import { unassignMissionFromTripFolder } from '../../../api/trip-folder/unassign-mission-from-trip-folder'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import { queryClient } from '../../../main'

interface Props {
  folderId: number
  missionId: number
}

const UnassignTripFolderMissionButton = ({ folderId, missionId }: Props) => {
  const { mutate: unassignMission, isPending: isUnassigningMission } = useMutation({
    mutationFn: unassignMissionFromTripFolder,
    onError: showAxiosError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trip-folder-missions', folderId] })
      queryClient.invalidateQueries({ queryKey: [API.missions.getAll.url] })
      toast.success('Mission désassignée avec succès')
    }
  })

  return (
    <Fragment>
      <ActionButton
        disabled={isUnassigningMission}
        isLoading={isUnassigningMission}
        icon={UnlinkIcon}
        variant="grey"
        onClick={() => unassignMission({ id: folderId, missionId })}
      />
    </Fragment>
  )
}

export default UnassignTripFolderMissionButton
